/**
 * Converts various input formats into a human-readable notification message.
 * @param input - The input to be converted, which can be an object, array, or string.
 * @returns A human-readable string message.
 */
export function formatError(input: unknown): string {
  if (input instanceof Error) {
    // Handle standard Error objects
    return input.message;
  } else if (typeof input === 'string') {
    // Attempt to parse the string as JSON
    try {
      const parsed = JSON.parse(input);
      return formatError(parsed);
    } catch {
      // If parsing fails, return the original string
      return input;
    }
  } else if (Array.isArray(input)) {
    // Input is an array
    const messages = input.map((item) => formatError(item));
    return messages.join('; ');
  } else if (typeof input === 'object' && input !== null) {
    // Input is a plain object
    try {
      // Input is an object
      const messages = Object.values(input).map((value) => formatError(value));
      return messages.join('. ');
    } catch {
      return 'An unknown error occurred.';
    }
  } else {
    // Input is of an unrecognized type
    return 'An unknown error occurred.';
  }
}
